"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TokenService = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _StorageService = require("../StorageService");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TokenService = /*#__PURE__*/function () {
  function TokenService(_ref) {
    var _ref$storageService = _ref.storageService,
        storageService = _ref$storageService === void 0 ? _StorageService.cookiesStorage : _ref$storageService,
        _ref$tokenName = _ref.tokenName,
        tokenName = _ref$tokenName === void 0 ? 'alyce_access_token' : _ref$tokenName,
        _ref$refreshTokenName = _ref.refreshTokenName,
        refreshTokenName = _ref$refreshTokenName === void 0 ? 'alyce_refresh_token' : _ref$refreshTokenName,
        _ref$cookieAttrs = _ref.cookieAttrs,
        cookieAttrs = _ref$cookieAttrs === void 0 ? {} : _ref$cookieAttrs,
        _ref$minTimeToExpire = _ref.minTimeToExpire,
        minTimeToExpire = _ref$minTimeToExpire === void 0 ? 300 : _ref$minTimeToExpire;
    (0, _classCallCheck2["default"])(this, TokenService);
    (0, _defineProperty2["default"])(this, "storageService", void 0);
    (0, _defineProperty2["default"])(this, "tokenName", void 0);
    (0, _defineProperty2["default"])(this, "refreshTokenName", void 0);
    (0, _defineProperty2["default"])(this, "cookieAttrs", void 0);
    (0, _defineProperty2["default"])(this, "minTimeToExpire", void 0);
    this.storageService = storageService;
    this.tokenName = tokenName;
    this.refreshTokenName = refreshTokenName;
    this.cookieAttrs = cookieAttrs;
    this.minTimeToExpire = minTimeToExpire;
  }

  (0, _createClass2["default"])(TokenService, [{
    key: "getToken",
    value: function getToken() {
      return this.storageService.getItem(this.tokenName);
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return this.storageService.getItem(this.refreshTokenName);
    }
  }, {
    key: "setToken",
    value: function setToken(value) {
      this.storageService.setItem(this.tokenName, value, this.cookieAttrs);
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(value) {
      this.storageService.setItem(this.refreshTokenName, value, this.cookieAttrs);
    }
  }, {
    key: "reset",
    value: function reset() {
      var resetRefreshToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.storageService.deleteItem(this.tokenName, this.cookieAttrs);

      if (resetRefreshToken) {
        this.storageService.deleteItem(this.refreshTokenName, this.cookieAttrs);
      }
    }
  }, {
    key: "getDecodedToken",
    value: function getDecodedToken() {
      return TokenService.decodeToken(this.getToken());
    }
  }, {
    key: "isExpired",
    value: function isExpired() {
      var currentTime = Math.floor(Date.now() / 1000);

      var _this$getDecodedToken = this.getDecodedToken(),
          isValid = _this$getDecodedToken.isValid,
          _this$getDecodedToken2 = _this$getDecodedToken.exp,
          expireAt = _this$getDecodedToken2 === void 0 ? 0 : _this$getDecodedToken2;

      var diff = isValid ? expireAt - currentTime : 0;
      return diff < this.minTimeToExpire;
    }
  }], [{
    key: "decodeToken",
    value: function decodeToken(token) {
      if (!token) {
        return {
          isValid: false
        };
      }

      try {
        return _objectSpread(_objectSpread({}, (0, _jwtDecode["default"])(token)), {}, {
          isValid: true
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Invalid token.', e);
        return {
          isValid: false
        };
      }
    }
  }]);
  return TokenService;
}();

exports.TokenService = TokenService;

var createTokenService = function createTokenService(options) {
  return new TokenService(options);
};

var _default = createTokenService;
exports["default"] = _default;